import { theme } from "../../../theme";
import styled from "styled-components";
import {
  ChevronSmallDownIcon,
  ChevronSmallLeftIcon,
  ChevronSmallRightIcon,
  ChevronSmallUpIcon,
} from "../icons/ChevronIcons";

interface Props {
  onClick: () => void;
  type: "up" | "down" | "left" | "right";
  disabled?: boolean;
}

const ButtonContiner = styled.button`
  border: none;
  background-color: ${theme.colors.grey05};
  padding: 0;
  cursor: pointer;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    cursor: default;
    opacity: 0.3;
  }

  &:hover {
    background-color: ${theme.colors.secondaryHover};
  }
`;

const ChevronButton: React.FC<Props> = ({ onClick, type, disabled }) => {
  return (
    <ButtonContiner onClick={onClick} disabled={disabled}>
      {type === "up" ? (
        <ChevronSmallUpIcon color={theme.colors.primary60} />
      ) : type === "down" ? (
        <ChevronSmallDownIcon color={theme.colors.primary60} />
      ) : type === "left" ? (
        <ChevronSmallLeftIcon color={theme.colors.primary60} />
      ) : (
        <ChevronSmallRightIcon color={theme.colors.primary60} />
      )}
    </ButtonContiner>
  );
};

export default ChevronButton;
